import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { Button } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { SwiperRef } from 'swiper/react';
import 'swiper/css';
import ImgCard1 from '../../assets/image/education/img_education_card1.png';
import ImgCard2 from '../../assets/image/education/img_education_card2.png';
import ImgCard3 from '../../assets/image/education/img_education_card3.png';
import FullHeightContainer from '../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../component/common/TopHeaderWithPrev';
import BottomTwoBtnDialog from '../../component/common/BottomTwoBtnDialog';
import { useTranslation } from '../../hook/useTranslation';

interface Card {
  id: number;
  name: string;
  image: string;
}

function EducationPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [alarmDialogOpen, setAlarmDialogOpen] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const cards: Card[] = [
    { id: 1, name: 'Habit 1', image: ImgCard1 },
    { id: 2, name: 'Habit 2', image: ImgCard2 },
    { id: 3, name: 'Habit 3', image: ImgCard3 },
  ];
  const swiperRef = useRef<SwiperRef>(null);

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title="" onClickPrev={() => navigate(Url.Home)} />
      <div className="absolute top-[15px] right-[20px] text-[14px] font-[400] text-[#969696] underline">
        {t('education.apply_business')}
      </div>
      <div className="pageInner" style={{ padding: '0 0 50px 0' }}>
        <div className="w-full flex flex-col items-center justify-center gap-2 px-[20px] my-[30px]">
          <div className="text-[28px] font-[700]">
            {t('education.title_line1')}
            <br />
            {t('education.title_line2')}
          </div>
          <div className="text-[#363636] text-[14px] font-[400]">
            {t('education.subtitle')}
          </div>
        </div>
        <div className="w-full mt-[20px]">
          <Swiper
            ref={swiperRef}
            spaceBetween={-20}
            slidesPerView="auto"
            initialSlide={0}
            centeredSlides
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          >
            {cards.map((card, index) => {
              const active = index === activeIndex;
              return (
                <SwiperSlide
                  key={card.id}
                  style={{ maxWidth: '250px' }}
                  className="!flex !justify-center"
                >
                  <img
                    src={card.image}
                    alt={card.name}
                    className="w-full h-auto"
                    style={{
                      transform: active ? 'scale(1)' : 'scale(0.7)',
                      transition: 'transform 0.3s ease',
                      transformOrigin: 'center center',
                    }}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className="w-full flex justify-center mt-[20px]">
          <div
            className="w-[6px] h-[6px] rounded-full bg-[#D9D9D9] mx-[3px]"
            style={{ background: activeIndex === 0 ? '#000' : '#d9d9d9' }}
          ></div>
          <div
            className="w-[6px] h-[6px] rounded-full bg-[#D9D9D9] mx-[3px]"
            style={{ background: activeIndex === 1 ? '#000' : '#d9d9d9' }}
          ></div>
          <div
            className="w-[6px] h-[6px] rounded-full bg-[#D9D9D9] mx-[3px]"
            style={{ background: activeIndex === 2 ? '#000' : '#d9d9d9' }}
          ></div>
        </div>
      </div>
      <div className="w-full px-[20px] bg-white py-[10px]">
        <Button variant="contained" fullWidth onClick={() => setAlarmDialogOpen(true)}>
          {t('education.get_notified')}
        </Button>
      </div>
      <BottomTwoBtnDialog
        open={alarmDialogOpen}
        onClose={() => setAlarmDialogOpen(false)}
        title={t('education.alert_title')}
        description={t('education.alert_desc')}
        leftBtnText={t('common.cancel')}
        rightBtnText={t('common.agree')}
        leftBtnClick={() => setAlarmDialogOpen(false)}
        rightBtnClick={() => {
          setAlarmDialogOpen(false);
        }}
      />
    </FullHeightContainer>
  );
}

export default EducationPage;
